import React from "react";
import PropTypes from "prop-types";

import { Link } from "gatsby";

const PLink = ({ href, to, className, children, underline }) => {
  let PLinkElement;
  let PLinkProps = {};

  if (to) {
    PLinkElement = Link;
    PLinkProps.to = to;
  }

  if (href) {
    PLinkElement = "a";
    if (typeof href === "string") {
      PLinkProps.href = href;
    }
    // to open the link on a new tab, make href an object with the property "url"
    if (typeof href === "object") {
      PLinkProps.href = href.url;
      PLinkProps.target = "_blank";
      PLinkProps.rel = "noreferrer";
    }
  }

  const plinkStyle = underline && "underline ";

  return (
    <PLinkElement className={`${plinkStyle} ${className}`} {...PLinkProps}>
      {children}
    </PLinkElement>
  );
};

PLink.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  to: PropTypes.string,
};

export { PLink };
